import { Segment } from ".";
import { SelectionTypeEnum } from "./SelectionTypeEnum";

export class SegmentDefinition {
    segmentList: Segment[];
    selectionType: SelectionTypeEnum;

    constructor(segmentList: Segment[], selectionType: SelectionTypeEnum) {
        this.segmentList = segmentList ?? [];
        this.selectionType = selectionType;
    }
}
